import { SUCCESS, REQUEST } from 'lib/const'
import { isObj } from 'lib/utils'

function _vuexApiCall (type, apiParams, module, otherConfig) {
  module = module + '/'
  let isNamespace = module && this.$store._modulesNamespaceMap[module]
  const request = isNamespace ? module + REQUEST.toLowerCase() : REQUEST.toLowerCase()
  if (isNamespace) {
    return this.$store.dispatch(request, {
      type,
      isNamespace,
      module,
      apiParams,
      otherConfig
    })
  } else {
    return this.$store.dispatch({
      type,
      ...apiParams,
      ...otherConfig
    })
  }

}

/**
 * vuex公共api请求函数
 * @param module 模块名称
 * @param type 所需执行的api动作
 * @param apiParams 请求的参数
 * @param otherConfig 其他参数
 * @returns {Promise<any>}
 */
export default function vuexApiCall (type, module, apiParams = {}, otherConfig = {}) {
  if (isObj(type)) {
    otherConfig = type.otherConfig || {}
    module = type.module || 'common'
    apiParams = type.apiParams || {}
    type = type.type
  } else {
    if (isObj(module)) {
      otherConfig = apiParams || {}
      apiParams = module
      module = 'common'
    }
  }
  if (!type && typeof type !== 'string') {
    throw Error('请求type必须是string')
  }
  if (!apiParams.baseUrl) {
    apiParams.baseUrl = serverUrl
  }
  return _vuexApiCall.call(this, type, apiParams, module, otherConfig)

}
